module.exports = __webpack_public_path__ + "static/media/linked.9788140b.png";